import { Box, Button, Text } from '@mantine/core';
import { Lightbulb } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import type { ReactElement } from 'react';

/** Fallback shown when the URL doesn't resolve to a known surface, topic, or slice. */
export default function TopicNotFound(): ReactElement {
    const navigate = useNavigate();
    return (
        <Box ta="center" py="xl">
            <Box
                mx="auto"
                mb="md"
                style={{ width: 44, height: 44, display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bm-color-surface)', border: '1px solid var(--bm-color-border)' }}
            >
                <Lightbulb size={20} color="var(--bm-color-text-dimmed)" />
            </Box>
            <Text fw={700} mb={4}>
                That topic isn’t here
            </Text>
            <Text size="sm" c="dimmed" mb="lg">
                The page you followed doesn’t exist or has moved.
            </Text>
            <Button size="sm" variant="light" onClick={() => navigate('/')}>
                Back to home
            </Button>
        </Box>
    );
}
